import type { CustomElements } from '@trinity/custom-pages-registry-types';
import { DMKPISummary } from './DM/index.js';

type Props = {
  element: CustomElements;
};

export function CustomElementRenderer({ element }: Props): React.ReactElement {
  void element;
  return <DMKPISummary />;
}
